// import axios from "axios";
// import React from "react";
// import cookie from "react-cookies";
// import { WEB_BASE_URL } from "../../unified/webbase";

// class EditUser extends React.Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       networks: ["MTN", "9MOBILE", "GLO", "AIRTEL"],
//       token: cookie.load("token"),
//       spdAIRTEL: 0,
//       spdGLO: 0,
//       spdMTN: 0,
//       spd9MOBILE: 0,
//       pin: "",
//     };
//   }

//   componentDidMount() {

//   }

//   render() {
//     let ifEmailEditable = this.props.title === "Edit User" ? true : false;
//     return (
//       <div
//         className="modal fade"
//         id={this.props.id}
//         tabindex="-1"
//         aria-labelledby="exampleModalLabel"
//         aria-hidden="true"
//       >
//         <div className="modal-dialog modal-dialog-centered">
//           <div className="modal-content">
//             <div className="modal-header">
//               <h5 className="modal-title" id="exampleModalLabel">
//                 {this.props.title}
//               </h5>
//               <button
//                 type="button"
//                 className="btn-close"
//                 data-bs-dismiss="modal"
//                 aria-label="Close"
//               ></button>
//             </div>
//             <div className="modal-body">
//               <form className="row g-3">
//                 <div className="col-12">
//                   <label className="form-label">User Email</label>
//                   <input
//                     onChange={(event) => this.props.onChangeEmail(event)}
//                     type="email"
//                     className="form-control"
//                     value={this.props.formEmail}
//                     disabled={ifEmailEditable}
//                   />
//                 </div>
//                 {/* {this.state.networks.map((network, index) =>
//                 (
//                   <div className="col-12 my-2">
//                     <label className="form-label">{network}</label>
//                     <input
//                       type="text"
//                       name="dsp"
//                       placeholder="Selling Price Discounted"
//                       class="form-control"
//                       onChange={(e) => {
//                         this.setState({
//                           [`spd${network}`]: e.target.value,
//                         });
//                       }}
//                       disabled={false}
//                       required
//                     />
//                   </div>
//                 )
//                 )} */}
//                 {this.state.networks.map((network, index) => (
//   <div className="col-12 my-2" key={index}>
//     <label className="form-label">{network}</label>
//     <input
//       type="text"
//       name="dsp"
//       placeholder="Selling Price Discounted"
//       className="form-control"
//       value={this.state[`spd${network}`]}
//       onChange={(e) => {
        
//         let value = e.target.value;
    
//         value = value.replace(/[^0-9.]/g, "");
//         const parts = value.split(".");
//         if (parts.length > 2) {
//           value = parts[0] + "." + parts[1];
//         }
//         this.setState({
//           [`spd${network}`]: value,
//         });
//       }}
//       required
//     />
//   </div>
// ))}

//                 <div className="col-12 my-2">
//                   <label className="form-label">Authenticator Code</label>
//                   <input
//                     type="text"
//                     name="dsp"
//                     placeholder="Authenticator Code"
//                     class="form-control"
//                     onChange={(e) => {
//                       this.setState({
//                         pin: e.target.value,
//                       });
//                     }}
//                     disabled={false}
//                     required
//                   />
//                 </div>
//               </form>
//             </div>
//             <div className="modal-footer">
//               <button
//                 onClick={(e) => {
//                   this.props.onSubmit(
//                     e,
//                     this.props.accountId,
//                     this.props.table_id,
//                     this.props.formEmail,
//                     this.state.spd9MOBILE,
//                     this.state.spdMTN,
//                     this.state.spdGLO,
//                     this.state.spdAIRTEL,
//                     this.state.pin
//                   );
//                 }}
//                 type="button"
//                 className="btn btn-primary"
//               >
//                 {this.props.buttonText}
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   }
// }

// export default EditUser;

import axios from "axios";

// import axios from "axios";

// import React from "react";
// import cookie from "react-cookies";
// import { WEB_BASE_URL } from "../../unified/webbase";

// class EditUser extends React.Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       networks: ["MTN", "9MOBILE", "GLO", "AIRTEL"],
//       token: cookie.load("token"),
//       spdAIRTEL: "",
//       spdGLO: "",
//       spdMTN: "",
//       spd9MOBILE: "",
//       pin: "",
//     };
//   }

//   componentDidMount() {
//     this.prefillValues();
//     this.handleShow();
//   }

//   componentDidUpdate(prevProps) {
//     // Update when props change
//     if (
//       prevProps.spdMTN !== this.props.spdMTN ||
//       prevProps.spdGLO !== this.props.spdGLO ||
//       prevProps.spdAIRTEL !== this.props.spdAIRTEL ||
//       prevProps.spd9MOBILE !== this.props.spd9MOBILE
//     ) {
//       this.prefillValues();
//     }
//   }

//   // prefillValues = () => {
//   //   this.setState({
//   //     spdMTN: this.props.spdMTN ?? "",
//   //     spdGLO: this.props.spdGLO ?? "",
//   //     spdAIRTEL: this.props.spdAIRTEL ?? "",
//   //     spd9MOBILE: this.props.spd9MOBILE ?? "",
//   //   });
//   // };

//   prefillValues = () => {
//     const getValue = (value) => (value != null ? value : "");
    
//     this.setState({
//       spdMTN: getValue(this.props.spdMTN),
//       spdGLO: getValue(this.props.spdGLO),
//       spdAIRTEL: getValue(this.props.spdAIRTEL),
//       spd9MOBILE: getValue(this.props.spd9MOBILE),
//     });
//   };
//   handleShow = () => {
//     const modalElement = document.getElementById(this.props.id);
//     if (modalElement) {
//       // Remove existing listener to prevent duplicates
//       modalElement.removeEventListener("shown.bs.modal", this.prefillValues);
//       // Add new listener
//       modalElement.addEventListener("shown.bs.modal", this.prefillValues);
//     }
//   };

//   componentWillUnmount() {
//     const modalElement = document.getElementById(this.props.id);
//     if (modalElement) {
//       modalElement.removeEventListener("shown.bs.modal", this.prefillValues);
//     }
//   }

//   render() {
//     const ifEmailEditable = this.props.title === "Edit User";

//     return (
//       <div
//         className="modal fade"
//         id={this.props.id}
//         tabIndex="-1"
//         aria-labelledby="exampleModalLabel"
//         aria-hidden="true"
//       >
//         <div className="modal-dialog modal-dialog-centered">
//           <div className="modal-content">
//             <div className="modal-header">
//               <h5 className="modal-title">{this.props.title}</h5>
//               <button
//                 type="button"
//                 className="btn-close"
//                 data-bs-dismiss="modal"
//                 aria-label="Close"
//               ></button>
//             </div>

//             <div className="modal-body">
//               <form className="row g-3">
//                 <div className="col-12">
//                   <label className="form-label">User Email</label>
//                   <input
//                     onChange={this.props.onChangeEmail}
//                     type="email"
//                     className="form-control"
//                     value={this.props.formEmail}
//                     disabled={ifEmailEditable}
//                   />
//                 </div>

//                 {this.state.networks.map((network, index) => (
//                   <div className="col-12 my-2" key={index}>
//                     <label className="form-label">{network}</label>
//                     <input
//                       type="text"
//                       name={`spd${network}`}
//                       placeholder="Selling Price Discounted"
//                       className="form-control"
//                       value={this.state[`spd${network}`]}
//                       onChange={(e) => {
//                         let value = e.target.value.replace(/[^0-9.]/g, "");
//                         const parts = value.split(".");
//                         if (parts.length > 2) value = parts[0] + "." + parts[1];
//                         this.setState({ [`spd${network}`]: value });
//                       }}
//                       required
//                     />
//                   </div>
//                 ))}

//                 <div className="col-12 my-2">
//                   <label className="form-label">Authenticator Code</label>
//                   <input
//                     type="text"
//                     placeholder="Authenticator Code"
//                     className="form-control"
//                     onChange={(e) => this.setState({ pin: e.target.value })}
//                     required
//                   />
//                 </div>
//               </form>
//             </div>

//             <div className="modal-footer">
//               <button
//                 onClick={(e) =>
//                   this.props.onSubmit(
//                     e,
//                     this.props.accountId,
//                     this.props.table_id,
//                     this.props.formEmail,
//                     String(this.state.spd9MOBILE),
//                     String(this.state.spdMTN),
//                     String(this.state.spdAIRTEL),
//                     String(this.state.spdGLO),
//                     this.state.pin
//                   )
//                 }
//                 type="button"
//                 className="btn btn-primary"
//               >
//                 {this.props.buttonText}
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   }
// }

// export default EditUser;

// import React from "react";
// import cookie from "react-cookies";
// import { WEB_BASE_URL } from "../../unified/webbase";

// class EditUser extends React.Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       networks: ["MTN", "9MOBILE", "GLO", "AIRTEL"],
//       token: cookie.load("token"),
//       spdAIRTEL: props.spdAIRTEL != null ? props.spdAIRTEL : "",
//       spdGLO: props.spdGLO != null ? props.spdGLO : "",
//       spdMTN: props.spdMTN != null ? props.spdMTN : "",
//       spd9MOBILE: props.spd9MOBILE != null ? props.spd9MOBILE : "",
//       pin: "",
//     };
//   }

//   componentDidMount() {
//     this.handleShow();
//   }

//   componentDidUpdate(prevProps) {
//     // Update when props change
//     if (
//       prevProps.spdMTN !== this.props.spdMTN ||
//       prevProps.spdGLO !== this.props.spdGLO ||
//       prevProps.spdAIRTEL !== this.props.spdAIRTEL ||
//       prevProps.spd9MOBILE !== this.props.spd9MOBILE
//     ) {
//       this.prefillValues();
//     }
//   }

//   prefillValues = () => {
//     this.setState({
//       spdMTN: this.props.spdMTN != null ? this.props.spdMTN : "",
//       spdGLO: this.props.spdGLO != null ? this.props.spdGLO : "",
//       spdAIRTEL: this.props.spdAIRTEL != null ? this.props.spdAIRTEL : "",
//       spd9MOBILE: this.props.spd9MOBILE != null ? this.props.spd9MOBILE : "",
//     });
//   };

//   handleShow = () => {
//     const modalElement = document.getElementById(this.props.id);
//     if (modalElement) {
//       // Remove existing listener to prevent duplicates
//       modalElement.removeEventListener("shown.bs.modal", this.prefillValues);
//       // Add new listener
//       modalElement.addEventListener("shown.bs.modal", this.prefillValues);
//     }
//   };

//   componentWillUnmount() {
//     const modalElement = document.getElementById(this.props.id);
//     if (modalElement) {
//       modalElement.removeEventListener("shown.bs.modal", this.prefillValues);
//     }
//   }

//   render() {
//     const ifEmailEditable = this.props.title === "Edit User";

//     return (
//       <div
//         className="modal fade"
//         id={this.props.id}
//         tabIndex="-1"
//         aria-labelledby="exampleModalLabel"
//         aria-hidden="true"
//       >
//         <div className="modal-dialog modal-dialog-centered">
//           <div className="modal-content">
//             <div className="modal-header">
//               <h5 className="modal-title">{this.props.title}</h5>
//               <button
//                 type="button"
//                 className="btn-close"
//                 data-bs-dismiss="modal"
//                 aria-label="Close"
//               ></button>
//             </div>

//             <div className="modal-body">
//               <form className="row g-3">
//                 <div className="col-12">
//                   <label className="form-label">User Email</label>
//                   <input
//                     onChange={this.props.onChangeEmail}
//                     type="email"
//                     className="form-control"
//                     value={this.props.formEmail}
//                     disabled={ifEmailEditable}
//                   />
//                 </div>

//                 {this.state.networks.map((network, index) => (
//                   <div className="col-12 my-2" key={index}>
//                     <label className="form-label">{network}</label>
//                     <input
//                       type="text"
//                       name={`spd${network}`}
//                       placeholder="Selling Price Discounted"
//                       className="form-control"
//                       value={this.state[`spd${network}`]}
//                       onChange={(e) => {
//                         let value = e.target.value.replace(/[^0-9.]/g, "");
//                         const parts = value.split(".");
//                         if (parts.length > 2) value = parts[0] + "." + parts[1];
//                         this.setState({ [`spd${network}`]: value });
//                       }}
//                       required
//                     />
//                   </div>
//                 ))}

//                 <div className="col-12 my-2">
//                   <label className="form-label">Authenticator Code</label>
//                   <input
//                     type="text"
//                     placeholder="Authenticator Code"
//                     className="form-control"
//                     onChange={(e) => this.setState({ pin: e.target.value })}
//                     required
//                   />
//                 </div>
//               </form>
//             </div>

//             <div className="modal-footer">
//               <button
//                 onClick={(e) =>
//                   this.props.onSubmit(
//                     e,
//                     this.props.accountId,
//                     this.props.table_id,
//                     this.props.formEmail,
//                     String(this.state.spd9MOBILE),
//                     String(this.state.spdMTN),
//                     String(this.state.spdAIRTEL),
//                     String(this.state.spdGLO),
//                     this.state.pin
//                   )
//                 }
//                 type="button"
//                 className="btn btn-primary"
//               >
//                 {this.props.buttonText}
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   }
// }

// export default EditUser;

// import React from "react";
// import cookie from "react-cookies";
// import { WEB_BASE_URL } from "../../unified/webbase";

// class EditUser extends React.Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       networks: ["MTN", "9MOBILE", "GLO", "AIRTEL"],
//       token: cookie.load("token"),
//       spdAIRTEL: this.getValidValue(props.spdAIRTEL),
//       spdGLO: this.getValidValue(props.spdGLO),
//       spdMTN: this.getValidValue(props.spdMTN),
//       spd9MOBILE: this.getValidValue(props.spd9MOBILE),
//       pin: "",
//     };
//   }


//   getValidValue = (val) => {
//     if (val === null || val === undefined || val === "") return "0";
//     return String(val);
//   };

//   componentDidMount() {
//     this.handleShow();
//   }

//   componentDidUpdate(prevProps) {
//     if (
//       prevProps.spdMTN !== this.props.spdMTN ||
//       prevProps.spdGLO !== this.props.spdGLO ||
//       prevProps.spdAIRTEL !== this.props.spdAIRTEL ||
//       prevProps.spd9MOBILE !== this.props.spd9MOBILE
//     ) {
//       this.prefillValues();
//     }
//   }

//   prefillValues = () => {
//     this.setState({
//       spdMTN: this.getValidValue(this.props.spdMTN),
//       spdGLO: this.getValidValue(this.props.spdGLO),
//       spdAIRTEL: this.getValidValue(this.props.spdAIRTEL),
//       spd9MOBILE: this.getValidValue(this.props.spd9MOBILE),
//     });
//   };

//   handleShow = () => {
//     const modalElement = document.getElementById(this.props.id);
//     if (modalElement) {
//       modalElement.removeEventListener("shown.bs.modal", this.prefillValues);
//       modalElement.addEventListener("shown.bs.modal", this.prefillValues);
//     }
//   };

//   componentWillUnmount() {
//     const modalElement = document.getElementById(this.props.id);
//     if (modalElement) {
//       modalElement.removeEventListener("shown.bs.modal", this.prefillValues);
//     }
//   }

//   render() {
//     const ifEmailEditable = this.props.title === "Edit User";

//     return (
//       <div
//         className="modal fade"
//         id={this.props.id}
//         tabIndex="-1"
//         aria-labelledby="exampleModalLabel"
//         aria-hidden="true"
//       >
//         <div className="modal-dialog modal-dialog-centered">
//           <div className="modal-content">
//             <div className="modal-header">
//               <h5 className="modal-title">{this.props.title}</h5>
//               <button
//                 type="button"
//                 className="btn-close"
//                 data-bs-dismiss="modal"
//                 aria-label="Close"
//               ></button>
//             </div>

//             <div className="modal-body">
//               <form className="row g-3">
//                 <div className="col-12">
//                   <label className="form-label">User Email</label>
//                   <input
//                     onChange={this.props.onChangeEmail}
//                     type="email"
//                     className="form-control"
//                     value={this.props.formEmail}
//                     disabled={ifEmailEditable}
//                   />
//                 </div>

//                 {/* ✅ Ensure each input always shows "0" if null */}
//                 {this.state.networks.map((network, index) => (
//                   <div className="col-12 my-2" key={index}>
//                     <label className="form-label">{network}</label>
//                     <input
//                       type="text"
//                       name={`spd${network}`}
//                       placeholder="Selling Price Discounted"
//                       className="form-control"
//                       value={this.state[`spd${network}`] || "0"}
//                       onChange={(e) => {
//                         let value = e.target.value.replace(/[^0-9.]/g, "");
//                         const parts = value.split(".");
//                         if (parts.length > 2) value = parts[0] + "." + parts[1];
//                         this.setState({ [`spd${network}`]: value });
//                       }}
//                       required
//                     />
//                   </div>
//                 ))}

//                 <div className="col-12 my-2">
//                   <label className="form-label">Authenticator Code</label>
//                   <input
//                     type="text"
//                     placeholder="Authenticator Code"
//                     className="form-control"
//                     onChange={(e) => this.setState({ pin: e.target.value })}
//                     required
//                   />
//                 </div>
//               </form>
//             </div>

//             <div className="modal-footer">
//               <button
//                 onClick={(e) =>
//                   this.props.onSubmit(
//                     e,
//                     this.props.accountId,
//                     this.props.table_id,
//                     this.props.formEmail,
//                     String(this.state.spd9MOBILE),
//                     String(this.state.spdMTN),
//                     String(this.state.spdAIRTEL),
//                     String(this.state.spdGLO),
//                     this.state.pin
//                   )
//                 }
//                 type="button"
//                 className="btn btn-primary"
//               >
//                 {this.props.buttonText}
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   }
// }

// export default EditUser;


import React from "react";
import cookie from "react-cookies";
import { WEB_BASE_URL } from "../../unified/webbase";

class EditUser extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      networks: ["MTN", "9MOBILE", "GLO", "AIRTEL"],
      token: cookie.load("token"),
      spdAIRTEL: this.getValidValue(props.spdAIRTEL),
      spdGLO: this.getValidValue(props.spdGLO),
      spdMTN: this.getValidValue(props.spdMTN),
      spd9MOBILE: this.getValidValue(props.spd9MOBILE),
      pin: "",
      activeInputs: {
        spdAIRTEL: false,
        spdGLO: false,
        spdMTN: false,
        spd9MOBILE: false
      }
    };
  }

  getValidValue = (val) => {
    if (val === null || val === undefined || val === "") return "0";
    return String(val);
  };

  componentDidMount() {
    this.handleShow();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.spdMTN !== this.props.spdMTN ||
      prevProps.spdGLO !== this.props.spdGLO ||
      prevProps.spdAIRTEL !== this.props.spdAIRTEL ||
      prevProps.spd9MOBILE !== this.props.spd9MOBILE
    ) {
      this.prefillValues();
    }
  }

  prefillValues = () => {
    this.setState({
      spdMTN: this.getValidValue(this.props.spdMTN),
      spdGLO: this.getValidValue(this.props.spdGLO),
      spdAIRTEL: this.getValidValue(this.props.spdAIRTEL),
      spd9MOBILE: this.getValidValue(this.props.spd9MOBILE),
    });
  };

  handleShow = () => {
    const modalElement = document.getElementById(this.props.id);
    if (modalElement) {
      modalElement.removeEventListener("shown.bs.modal", this.prefillValues);
      modalElement.addEventListener("shown.bs.modal", this.prefillValues);
    }
  };

  componentWillUnmount() {
    const modalElement = document.getElementById(this.props.id);
    if (modalElement) {
      modalElement.removeEventListener("shown.bs.modal", this.prefillValues);
    }
  }

  handleInputChange = (network, e) => {
    const fieldName = `spd${network}`;
    let value = e.target.value.replace(/[^0-9.]/g, "");
    const parts = value.split(".");
    
    if (parts.length > 2) {
      value = parts[0] + "." + parts[1];
    }

 
    if (this.state[fieldName] === "0" && value.length > 0 && !this.state.activeInputs[fieldName]) {

      this.setState({
        activeInputs: {
          ...this.state.activeInputs,
          [fieldName]: true
        }
      });
    }

    this.setState({ 
      [fieldName]: value 
    });
  };

  handleInputFocus = (network) => {
    const fieldName = `spd${network}`;
    
    // When input gains focus and value is "0", clear it for new input
    if (this.state[fieldName] === "0") {
      this.setState({ 
        [fieldName]: "",
        activeInputs: {
          ...this.state.activeInputs,
          [fieldName]: true
        }
      });
    }
  };

  handleInputBlur = (network) => {
    const fieldName = `spd${network}`;
    
    
    if (this.state[fieldName] === "") {
      this.setState({ 
        [fieldName]: "0",
        activeInputs: {
          ...this.state.activeInputs,
          [fieldName]: false
        }
      });
    } else {
      // Reset active state when user leaves the field
      this.setState({
        activeInputs: {
          ...this.state.activeInputs,
          [fieldName]: false
        }
      });
    }
  };

  render() {
    const ifEmailEditable = this.props.title === "Edit User";

    return (
      <div
        className="modal fade"
        id={this.props.id}
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{this.props.title}</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>

            <div className="modal-body">
              <form className="row g-3">
                <div className="col-12">
                  <label className="form-label">User Email</label>
                  <input
                    onChange={this.props.onChangeEmail}
                    type="email"
                    className="form-control"
                    value={this.props.formEmail}
                    disabled={ifEmailEditable}
                  />
                </div>

              
                {this.state.networks.map((network, index) => (
                  <div className="col-12 my-2" key={index}>
                    <label className="form-label">{network}</label>
                    <input
                      type="text"
                      name={`spd${network}`}
                      placeholder="Selling Price Discounted"
                      className="form-control"
                      value={this.state[`spd${network}`]}
                      onChange={(e) => this.handleInputChange(network, e)}
                      onFocus={() => this.handleInputFocus(network)}
                      onBlur={() => this.handleInputBlur(network)}
                      required
                    />
                  </div>
                ))}

                <div className="col-12 my-2">
                  <label className="form-label">Authenticator Code</label>
                  <input
                    type="text"
                    placeholder="Authenticator Code"
                    className="form-control"
                    onChange={(e) => this.setState({ pin: e.target.value })}
                    required
                  />
                </div>
              </form>
            </div>

            <div className="modal-footer">
              {/* <button
                onClick={(e) =>
                  this.props.onSubmit(
                    e,
                    this.props.accountId,
                    this.props.table_id,
                    this.props.formEmail,
                    String(this.state.spd9MOBILE),
                    String(this.state.spdMTN),
                    String(this.state.spdAIRTEL),
                    String(this.state.spdGLO),
                    this.state.pin
                  )
                }
                type="button"
                className="btn btn-primary"
              >
                {this.props.buttonText}
              </button> */}

<button
  onClick={(e) =>
    this.props.onSubmit(
      e,
      this.props.accountId,
      // this.props.table_id,
      this.props.formEmail,
      String(this.state.spd9MOBILE),
      String(this.state.spdMTN),
      String(this.state.spdGLO),    
      String(this.state.spdAIRTEL),   
      this.state.pin
    )
  }
  type="button"
  className="btn btn-primary"
>
  {this.props.buttonText}
</button>

            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default EditUser;